import React from 'react';

import { LoanPaidOffWrapper, Text } from './LoanPaidOff.styles';

const LoanPaidOff = () => (
  <LoanPaidOffWrapper>
    <Text data-testid="loan-card-paid-off-body-text">
      Congratulations, your loan is paid off!
    </Text>
  </LoanPaidOffWrapper>
);

export default LoanPaidOff;
